import { NotificationsService } from '@services/notifications/notifications.service';
import { ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ObservatoryService } from '@services/services.module';
import { TranslateService } from '@ngx-translate/core';
import { ModalMonthService } from './modal-month.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-month',
  templateUrl: './modal-month.component.html',
  styleUrls: ['./modal-month.component.scss']
})
export class ModalMonthComponent implements OnInit, OnDestroy {

  @Input() monthString;
  @Input() YearString;
  @Output() update: EventEmitter<any> = new EventEmitter();

  data;
  workingDay;
  dayListToMonth: Array<any>;
  inputDayData;
  inputations = [];
  monthlyImputationData = [];

  timeInPerson = 0;
  excessOfTime;
  breakTime;
  startTimeTxt;
  endTimeTxt;

  sumTempS1;
  sumHours: number = 0;
  dateMonthEnd: any;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private modalService: NgbModal,
    private notification: NotificationsService,
    private observatoryService: ObservatoryService,
    public translate: TranslateService,
    public modalMonthService: ModalMonthService
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.observatoryService.getData('timeInPerson').subscribe(data => {
        if (data) {
          this.timeInPerson = data;
        }
      }),
      this.observatoryService.getData('excessOfTime').subscribe(val => {
        this.excessOfTime = val;
      }),
      this.observatoryService.getData('breakTime').subscribe(val => {
        this.breakTime = val;
      }),
      this.observatoryService.getData('startTimeTxt').subscribe(val => {
        this.startTimeTxt = val;
      }),
      this.observatoryService.getData('endTimeTxt').subscribe(val => {
        this.endTimeTxt = val;
      }),
      this.observatoryService.getData('dayListToMonth').subscribe(data => {
        if (data.length) {
          this.dayListToMonth = Object.assign({}, data);
          this.workingDay = data[0].workingDay;
        }
      }),
      this.observatoryService.getData('dateMonthEnd').subscribe(data => {
        if (data) {
          this.dateMonthEnd = data;
        }
      })
    );
  }

  addRow(): void {
    const item = new ImputationsData();
    item.activityTypeId = '1';
    item.startTime = '09:00:00';
    item.endTime = '18:00:00';
    item.breakTime = 1;
    this.inputations.push(item);
    this.refreshData();
  }

  refreshData() {
    // total horas s1
    this.sumTempS1 = 0;
    this.inputations.forEach(element => {

      element.startTime = this.startTimeTxt;
      element.endTime = this.endTimeTxt;
      element.breakTime = this.breakTime;
      element.timeInPerson = this.timeInPerson;
      element.excessOfTime = this.excessOfTime;

      this.sumTempS1 = this.sumTempS1 + Number(element.hours);
    });

    this.refreshHours();
  }

  refreshHours() {
    this.sumHours = 0;
    this.inputations.forEach(element => {
      this.sumHours = this.sumHours + Number(element.hours);
      if (this.sumHours > this.timeInPerson) {
        this.notification.setWarning(this.translate.instant('CALENDARIO.PRESENCE_HR'));
      }
    });
  }

  isEmpty(obj): boolean {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  deleterow(fila: ImputationsData): void {
    if (fila) {
      const index: number = this.inputations.indexOf(fila);
      if (index !== -1) {
        this.inputations.splice(index, 1);
        this.refreshData();
      }
      return;
    }
  }

  closeImputations(): void {
    if (this.cleanEmptyRows()) {

      if (this.inputations.length) {
        const tipoS1 = this.inputations.find((imp: ImputationsData) => imp.activityTypeId === '1');
        if (!tipoS1) {
          this.notification.setError(this.translate.instant('CALENDARIO.NO_S1_IMPUT'));
          return;
        }
        if (this.sumHours !== Number(this.workingDay)) {
          this.notification.setError(this.translate.instant('ERRORS.ERRESSHOUDIFS1WORDAYVIS'));
          return;
        }
        if (this.validarImputaciones()) {

          this.cancelImputations();

        }
      } else {
        this.cancelImputations();
      }

    }
  }

  cancelImputations(): void {
    // borramos las imputaciones guardadas
    this.observatoryService.setData('imputationS1', []);
    this.observatoryService.setData('imputationS2S3', []);
    this.modalService.dismissAll();
  }

  saveImputations() {
    if (this.cleanEmptyRows()) {

      if (this.inputations.length) {
        const tipoS1 = this.inputations.find((imp: ImputationsData) => imp.activityTypeId === '1');
        if (!tipoS1) {
          this.notification.setError(this.translate.instant('CALENDARIO.NO_S1_IMPUT'));
          return;
        }
        if (this.sumHours !== Number(this.workingDay)) {
          this.notification.setError(this.translate.instant('ERRORS.ERRESSHOUDIFS1WORDAYVIS'));
          return;
        }
        if (this.validarImputaciones()) {

          this.prepareDataToImputMonth();

        }
      } else {
        this.cancelImputations();
      }

    }
  }

  validarImputaciones(): boolean {
    // tslint:disable-next-line:forin
    for (const i in this.inputations) {

      // tiempo de descanso negativo
      if (this.inputations[i].breakTime < 0) {
        this.notification.setError(this.translate.instant('CALENDARIO.REST_TIME_POSITIVE'));
        return false;
      }
      // tiempo de descanso mayor que la jornada laboral
      if (this.inputations[i].breakTime > this.workingDay) {
        this.notification.setError(this.translate.instant('CALENDARIO.REST_TIME_LOWER'));
        return false;
      }
      // tiempo de descanso multiplo de 0.5
      if (this.inputations[i].breakTime % 0.5 !== 0) {
        this.notification.setError(this.translate.instant('CALENDARIO.REST_TIME_MULTIPL'));
        return false;
      }
      // horas multiplo de 0.5
      if (this.inputations[i].hours % 0.5 !== 0) {
        this.notification.setError(this.translate.instant('CALENDARIO.HOURS_MULTIPL'));
        return false;
      }
      // hora entrada mayor que salida
      if (this.makeDate(this.inputations[i].startTime) >= this.makeDate(this.inputations[i].endTime)) {
        this.notification.setError(this.translate.instant('CALENDARIO.HR_ENTR'));
        return false;
      }
      if (!this.inputations[i].hours || !this.inputations[i].sapId || !this.inputations[i].activityTypeId) {
        this.notification.setError(this.translate.instant('CALENDARIO.REQUIRED_PHA_S2S3'));
        return false;
      }
      if ((Number(this.timeInPerson) !== this.sumTempS1 || Number(this.inputations[i].hours) < 0.5)) {
        if (Number(this.timeInPerson) < this.sumTempS1) {
          this.notification.setError(this.translate.instant('CALENDARIO.S1_OFFICE_LIMIT_SUP') + this.timeInPerson + this.translate.instant('CALENDARIO.NO_IMPUT_DONE'));
        } else {
          this.notification.setError(this.translate.instant('CALENDARIO.S1_OFFICE_LIMIT_INF') + this.timeInPerson + this.translate.instant('CALENDARIO.NO_IMPUT_DONE'));
        }
        return false;
      }

    }

    return true;
  }

  makeDate(data) {
    const date = new Date();
    date.setHours(Number(this.getHH(data)));
    date.setMinutes(Number(this.getMM(data)));
    date.setSeconds(Number(this.getSS(data)));

    return date;
  }

  convertImputationsToSend(imputations: Array<ImputationsData>): Array<ImputationsData> {
    if (imputations.length) {
      for (const i in imputations) {
        if (imputations[i].hours) {
          imputations[i].hours = imputations[i].hours.toString();
        }
      }
      return imputations;
    }
  }

  cleanEmptyRows(): boolean {
    if (this.inputations) {
      for (let i = 0; i < this.inputations.length; i++) {
        if (!this.inputations[i].projectId && !this.inputations[i].sapId &&
          !this.inputations[i].hours) { // && !this.inputations[i].activityTypeId
          this.inputations.splice(i--, 1);
        }
      }
    }
    return true;
  }

  private getHH(fecha): string {
    return fecha.substring(0, 2);
  }

  private getMM(fecha): string {
    return fecha.substring(3, 5);
  }

  private getSS(fecha): string {
    return fecha.substring(6, 8);
  }

  private getMonth(fecha): string {
    return fecha.substring(4, 6);
  }

  prepareDataToImputMonth(): void {

    // Elimino días con locked === 'T' || festive === 'T' y los que ya tienen una imputación asociada
    // tslint:disable-next-line: forin
    for (const i in this.dayListToMonth) {

      if (this.dayListToMonth[i].locked === 'F' && this.dayListToMonth[i].festive === 'F'
        && this.dayListToMonth[i].imputations.length < 1 && this.getMonth(this.dayListToMonth[i].date) === this.dateMonthEnd) {
        this.monthlyImputationData.push(this.dayListToMonth[i]);
      }
    }

    if (this.monthlyImputationData.length === 0) {
      this.notification.setError(this.translate.instant('CALENDARIO.ERROR_IMPUTAR_MES'));
      return;
    }

    // Asigno horas al workingDay y activityTipe siempre S1
    for (let i = 0; i < this.monthlyImputationData.length; i++) {
      for (let j = 0; j < this.inputations.length; j++) {
        this.monthlyImputationData[i].imputations.push(this.inputations[j]);
      }
    }

    this.subscriptions.push(
      this.modalMonthService.saveMonth(this.monthlyImputationData).subscribe(data => {
        if (data.response === 'OK') {
          this.cancelImputations();
          this.notification.setSuccess(this.translate.instant('CALENDARIO.EXITOMENSAJE'));
          this.update.emit();
        } else {
          this.notification.setError(this.translate.instant('CALENDARIO.ADVMENSAJE'));
        }
      })
    );

  }

  /**
  * @name ngOnDestroy
  * @description Lifecycle hook
  */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
